const comments = [
  {
    name: '吃瓜小能手',
    avatar: 'C',
    time: '3天前',
    content: '找了好久的51吃瓜最新地址终于在这里找到了！之前总是遇到各种打不开的链接，现在通过51吃瓜网入口直接就能稳定访问51吃瓜网在线内容，太方便了。热门吃瓜板块每天都有新内容，热度榜单也更新得很及时，已经成为我每天必刷的网站了。',
    likes: 286,
  },
  {
    name: '娱乐追踪者',
    avatar: 'Y',
    time: '5天前',
    content: '作为一个重度吃瓜爱好者，我用过很多类似的网站，但51吃瓜网入口的体验真的不错。51吃瓜网站入口很稳定，内容分类也很清晰，尤其是专题合集功能，让我能按兴趣快速找到想看的内容。之前一直困惑51吃瓜网怎么进，现在收藏这个51吃瓜官方入口就解决了。',
    likes: 195,
  },
  {
    name: '八卦研究员',
    avatar: 'B',
    time: '1周前',
    content: '推荐给身边的朋友了！之前大家总是问我51吃瓜网址是什么、51吃瓜网怎么进，现在直接把这个51吃瓜网入口发给他们就行。内容更新速度很快，吃瓜视频板块也很有意思。希望后续能推出51吃瓜app下载，移动端用起来会更方便，不过现在的手机浏览器体验也已经很不错了。',
    likes: 157,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">用户评价</h2>
            <p className="text-sm md:text-base text-foreground-500">
              听听吃瓜群众对51吃瓜网入口的真实评价
            </p>
          </div>

          <div className="space-y-4 md:space-y-5">
            {comments.map((comment, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg p-5 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-base flex-shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                      <span className="text-xs text-foreground-400">{comment.time}</span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {comment.content}
                    </p>
                    <div className="flex items-center gap-4 mt-3">
                      <span className="flex items-center gap-1 text-xs text-foreground-400">
                        <i className="ri-thumb-up-line"></i>
                        {comment.likes}
                      </span>
                      <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                        <i className="ri-chat-3-line"></i>
                        回复
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}